import QuickDepositSelect from './QuickDepositSelect';

export default QuickDepositSelect;
